import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./screens/Home";
import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermsAndConditions from "./screens/TermsAndConditions";
import Blogs from "./screens/Blogs";
import SuccessStory from "./screens/SuccessStory";
import AdminDashboard from "./screens/AdminDashboard";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/team/:slug" element={<SuccessStory />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
